import axios from "axios";
import Vue from "vue";
import objectUtils from "../../util/objectUtils";
import helper from "../../util/helper";

const getDefaultSelectedCar = () => {
  return { name: "", carGroup: { id: null, name: "" } };
};

export default {
  state: () => ({
    selectedCar: getDefaultSelectedCar(),
    carTypes: [],
  }),

  mutations: {
    setSelectedCar(state, car) {
      Vue.set(state, "selectedCar", car);
    },
    setCarTypes(state, carTypes) {
      Vue.set(state, "carTypes", carTypes);
    },
    setDefaultSelectedCar(state) {
      Vue.set(state, "selectedCar", getDefaultSelectedCar());
    },
    setDefaultCarModule(state) {
      Vue.set(state, "selectedCar", getDefaultSelectedCar());
      Vue.set(state, "carTypes", []);
    },
  },

  actions: {
    //TODO: load, update, create
    createCarType: (context, request) => {
      return axios
        .post(context.getters.getMcServiceUrl + "/cars/entity", request, {})
        .then((response) => {
          return response;
        })
        .catch((err) => {
          return err.response;
        });
    },

    loadCarTypes: (context) => {
      return axios.get(context.getters.getMcServiceUrl + "/cars/entity").then((response) => {
        return objectUtils.convertPublishModelToUpdateModel(response.data);
      });
    },
    loadPublishedCarTypes: (context) => {
      return axios.get(context.getters.getMcServiceUrl + "/cars/entity/published").then((response) => {
        return response.data;
      });
    },

    loadSelectedCarTypeHistory: (context, request) => {
      return axios.get(context.getters.getMcServiceUrl + "/cars/history/" + request.id, {}).then((response) => {
        return response.data;
      });
    },

    deleteCarType: (context, car) => {
      return axios
        .delete(context.getters.getMcServiceUrl + "/cars/entity/" + car.id)
        .then((response) => {
          let intents = [];
          intents.push(response.data);
          car.intents = intents;
          car.intentId = response.data.id;
          return car;
        })
        .catch((err) => {
          if (err.response.status === 400) {
            context.commit("setWarningModalContent", err.response.data.message);
            return "warning";
          }
        });
    },
    deleteDraftCarType: (context, car) => {
      return axios
        .delete(context.getters.getMcServiceUrl + "/cars/draft/" + car.intentId)
        .then((response) => {
          return response;
        })
        .catch((err) => {
          if (err.response.status === 400) {
            context.commit("setWarningModalContent", err.response.data.message);
            return "warning";
          }
        });
    },

    publishCarType: (context, car) => {
      return axios.get(context.getters.getMcServiceUrl + "/cars/publish/" + car.intentId).then((response) => {
        if (response.data) {
          response.data.intentId = 0;
        }
        return response.data;
      });
    },

    rejectCarType: (context, car) => {
      return axios.get(context.getters.getMcServiceUrl + "/cars/reject/" + car.intentId).then((response) => {
        if (car.intents[0].type === "DELETE_CAR") {
          car.intents = null;
          car.intentId = 0;
        } else if (car.intents[0].type === "CREATE_CAR") {
          car.intents[0].status = "DRAFT";
        } else if (car.intents[0].type === "UPDATE_CAR") {
          car.intents[0].status = "DRAFT";
        }
        return response.data;
      });
    },

    sendToApprovalCarType: (context, car) => {
      return axios.get(context.getters.getMcServiceUrl + "/cars/sendToApproval/" + car.intentId).then((response) => {
        if (car.intents[0].type === "CREATE_CAR") {
          car.intents[0].status = "WAITING_APPROVAL";
        } else if (car.intents[0].type === "UPDATE_CAR") {
          car.intents[0].status = "WAITING_APPROVAL";
        }
        return response.data;
      });
    },

    recallCarType: (context, car) => {
      return axios.get(context.getters.getMcServiceUrl + "/cars/recall/" + car.intentId).then((response) => {
        helper.recallOrRejectEntity(car, "car");
        return response.data;
      });
    },
    cancelCarType: (context, car) => {
      return axios.get(context.getters.getMcServiceUrl + "/cars/cancel/" + car.intentId).then((response) => {
        return response.data;
      });
    },
  },

  getters: {
    getSelectedCar: (state) => {
      return state.selectedCar;
    },
    getCarTypes: (state) => {
      return state.carTypes;
    },
    // getPublishedCarTypes: state =>{
    //     return state.carTypes.filter((entity)=>{
    //         return entity.intentId === 0;
    //     })
    // }
  },
};
